<template>
    <div class="row">
        <div id="syncProgress"
             class="col-md-6 col-md-offset-3">
            <h4 class="status text-center">
                <span v-html="text"></span>
            </h4>
            <div class="progress">
                <div class="progress-bar progress-bar-striped active"
                     role="progressbar"
                     aria-valuenow="0"
                     aria-valuemin="0"
                     aria-valuemax="100"
                     :style="style">
                    <span class="sr-only">{{ percent }}% Complete</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: true,
        },
        percent: {
            type: Number,
            required: true,
        },
    },

    computed: {
        style() {
            return {
                width: this.percent + '%',
            };
        },
    },
};
</script>
